import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Warning as WarningIcon } from '@phosphor-icons/react/dist/ssr/Warning'

import { getToolDisplayName } from '@/lib/assistant-tool-metadata'
import type { ToolCallState } from '@/contexts/chat-context'

interface ToolProgressProps {
	toolCalls: ToolCallState[]
}

export function ToolProgress({ toolCalls }: ToolProgressProps) {
	// Running calls are narrated by the thinking indicator ("Checking …") —
	// this list is the resolved trail only, so they aren't narrated twice.
	const resolved = toolCalls.filter((tc) => tc.status !== 'running')
	if (!resolved.length) return null

	return (
		<Stack spacing={0.5} sx={{ mb: 1 }}>
			{resolved.map((tc) => (
				<Stack key={tc.id} direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
					{tc.status === 'error' ? (
						<WarningIcon size={14} color="var(--mui-palette-warning-main)" />
					) : (
						<Box
							sx={{
								alignItems: 'center',
								bgcolor: 'success.dark',
								borderRadius: '50%',
								display: 'inline-flex',
								flexShrink: 0,
								height: 14,
								justifyContent: 'center',
								width: 14,
							}}
						>
							{/* Phosphor's stroke scales with icon size and stays thin at
								this scale — drawn explicitly so the check is thick. */}
							<Box component="svg" sx={{ display: 'block', height: 9, width: 9 }} viewBox="0 0 12 12">
								<path
									d="M2.5 6.5 5 9 9.5 3.5"
									fill="none"
									stroke="#fff"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
								/>
							</Box>
						</Box>
					)}
					<Typography color="text.secondary" sx={{ fontSize: '0.75rem', fontStyle: 'italic' }} variant="body2">
						{getToolDisplayName(tc.name)}
					</Typography>
				</Stack>
			))}
		</Stack>
	)
}
